<template>
    <div>
        <div class="d-flex justify-content-between mb-2">
            <h3 class="card-title">Lista de Pagares</h3>
            <div class="d-flex">
                <PrimaryButton class="btn btn-primary ms-auto" data-toggle="modal" data-target="#promissoryNoteModal"
                    @click="promissoryNoteStore.openModal">
                    Generar
                </PrimaryButton>
            </div>
        </div>

        <div class="d-flex mt-3 mb-3">
            <input type="text" class="form-control" placeholder="Buscar Pagaré..."
                v-model="promissoryNoteStore.searchString" />
        </div>

        <div>
            <PromissoryNoteTable :promissoryNotes="promissoryNoteStore.paginatedS"
                @sort="promissoryNoteStore.sortBy($event)" @edit="promissoryNoteStore.editData($event)" />
            <Pagination v-if="promissoryNoteStore.filteredS.length > promissoryNoteStore.itemsPerPage"
                :list="promissoryNoteStore.filteredS" :items-per-page="promissoryNoteStore.itemsPerPage"
                :current-page="promissoryNoteStore.currentPage"
                @current-page="promissoryNoteStore.setCurrentPage($event)" />
        </div>
        <!--:customClass="'modal-xl'"-->
        <Modal modal-id="promissoryNoteModal">
            <div class="modal-header">
                <h4 class="modal-title">Pagaré</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="promissoryNoteStore.closeModal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="col-12 col-md-3 col-lg-3 content-col">
                                <label for="applicationSelect" class="mb-0 font-weight-lb">Solicitud:</label>
                            </div>

                            <div class="col-12 col-md-4 col-lg-4" v-show="!promissoryNoteStore.isEdit">
                                <select id="applicationSelectPN" v-model="promissoryNoteStore.selectedApplication"
                                    class="form-select selectpicker border-dark" data-width="100%"
                                    data-live-search="true"
                                    :disabled="!promissoryNoteStore.loanApplicationsOptions.length && promissoryNoteStore.loanApplicationsOptions.loanApplications !== null"
                                    title="Selecciona solicitud...">
                                    <option value="" disabled>Selecciona solicitud</option>
                                    <option v-for="application in promissoryNoteStore.loanApplicationsOptions"
                                        :key="application.loanApplications?.id" :value="application">
                                        {{ application.loanApplications?.referenceNumber }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4 col-lg-4" v-show="promissoryNoteStore.isEdit">
                                <label for="applicationSelect" class="mb-0 font-weight-lb">
                                    {{ promissoryNoteStore?.form?.loanApplications?.referenceNumber || '' }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <PromissoryNote />
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    @click="promissoryNoteStore.closeModal">
                    {{ $getLocaleMessage('buttons', 'cancel') }}
                </button>
            </div>
        </Modal>
    </div>
</template>

<script setup>
import { onMounted, nextTick, computed, watch } from "vue";
import { usePromissoryNoteStore } from '@/pinia/LoanApplications/Legal/usePromissoryNoteStore.module';
import Modal from '@/Components/Bootstrap/Modal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import PromissoryNote from '@/Components/Forms/LoanApplications/Legal/PromissoryNote.vue';
import PromissoryNoteTable from "@/Components/Tables/PromissoryNoteTable.vue";
import Pagination from '@/Components/Bootstrap/Pagination.vue';

const promissoryNoteStore = usePromissoryNoteStore();
const getSelectPN = () => $('#applicationSelectPN');

// Inicializa el selectpicker
const initializeSelectPicker = () => {
    nextTick(() => {
        const select = getSelectPN();
        if (select.length) {
            select.selectpicker('refresh');
            if (!promissoryNoteStore.selectedApplication) {
                select.selectpicker('val', '');
            }
        }
    });
};

// Watcher para isModalOpen
watch(
    () => promissoryNoteStore.isModalOpen,
    (newValue) => {
        if (!newValue) {
            initializeSelectPicker();
        }
    },
);

// Watcher para las opciones del select
watch(
    () => promissoryNoteStore.loanApplicationsOptions,
    async (newOptions) => {
        if (newOptions.length > 0 && promissoryNoteStore.isModalOpen) {
            initializeSelectPicker();
        }
    },
    { deep: true }
);

// Watcher para actualizar datos cuando cambia selectedApplication
watch(
    () => promissoryNoteStore.selectedApplication,
    (newApp) => {
        if (!promissoryNoteStore.isEdit) {
            promissoryNoteStore.form = {};
        }

        if (newApp) {
            promissoryNoteStore.form = newApp;
        }
    },
    { deep: true, immediate: true } // Agrega esto para que se ejecute al montar el componente immediate
);

// Cargar data al montar el componente
onMounted(async () => {
    //Cargar data de opciones de solicitud
    await promissoryNoteStore.filterLoanApplications();
    //Cargar los datos de la tabla
    await promissoryNoteStore.fetchPromissoryNote();
    //Inicializar el componente de selector
    initializeSelectPicker();
});
</script>